import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class AccountUserEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "AccountUser";
        this.primaryEnterpriseComponent = "AccountUser";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "AccountUser";
        eom.enterpriseComponent = "AccountUser";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AccountUserPosition";
        eom.enterpriseComponent = "AccountUserPosition";
        eom.relationship = "AccountUserAccountUserPosition";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AccountUserUserGroup";
        eom.enterpriseComponent = "AccountUserUserGroup";
        eom.relationship = "AccountUserAccountUserUserGroup";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AccountUserWorkGroup";
        eom.enterpriseComponent = "AccountUserWorkGroup";
        eom.relationship = "AccountUserAccountUserWorkGroup";
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default AccountUserEnterpriseObjectMetadata;